function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_994:1127)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 3.49691e-06C8.9 1.55613e-06 -1.55613e-06 8.9 -3.49691e-06 20C-5.42021e-06 31 8.89999 40 20 40C31 40 40 31.1 40 20C39.9 8.90001 31 5.42021e-06 20 3.49691e-06ZM33 22.9L23.1 22.9L23.1 33L16.9 33L16.9 22.9L6.9 22.9L6.9 17L16.8 17L16.8 6.9L23 6.9L23 17L33 17L33 22.9Z",
  fill: "url(#paint0_linear_994:1127)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_994:1127",
  x1: -0.276703,
  y1: 19.9503,
  x2: 44.723,
  y2: 19.9503,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ED1B2F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7277,
  stopColor: "#124E91"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_994:1127"
}, /*#__PURE__*/React.createElement("rect", {
  width: 39.9,
  height: 39.9,
  fill: "white"
})));

var SvgIsoAraucoPlus = function SvgIsoAraucoPlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIsoAraucoPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iso-arauco-plus.00897c86.svg";
export { ForwardRef as ReactComponent };